module.exports = __webpack_public_path__ + "d52a2612628ed4cf27e9513b71b19d31.svg";